import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/time_logs/`, { params });
  },
  // createData() {
  //   return Backend.get('/time_logs/create');
  // },
  // editData(id) {
  //   return Backend.get(`/time_logs/${id}/edit`);
  // },
  // create(data) {
  //   return Backend.post('/time_logs/', data);
  // },
  // update(data) {
  //   return Backend.put(`/time_logs/${data.id}`, data);
  // },
  // delete(id) {
  //   return Backend.delete(`/time_logs/${id}`);
  // },
};
